// Created by carsonaberle at 4/13/21
import React, { useState } from 'react';
import './styles';
import { useDispatch, useSelector } from 'react-redux';
import UIOverlayCard from '../../UI/UIOverlayCard';
import UIIconButton from '../../UI/UIIconButton';
import UIListInputRow from '../../UI/UIListInputRow';
import UIBookableOption from '../../UI/UIBookableOption';
import UIModal from '../../UI/UIModal';
import SelectOptionModal from '../SelectOptionModal';
import { PlusIcon, Trashcan } from '../../../assets/icons';
import CreatePartnerPackageModalHelper from './helpers';
import UIIcon from '../../UI/UIIcon';
import { UI_LABELED_INPUT_CURRENCY_TYPE } from '../../UI/UILabeledInput/config';
import { setUpBookableOption } from '../../../pages/portal/global/EditOptions/config';
import { getSelectedRegionSelector } from '../../../redux/selectors/CurrentUserSelectors';
import { setSelectedRegion } from '../../../redux/store/user/actions';
import { useApolloClient } from 'react-apollo';

export default function CreatePartnerPackageModal({ partner, onCreateFinished, packageToEdit }: CreatePartnerPackageModalProps) {
	const selectedRegion = useSelector(getSelectedRegionSelector);

	const [showAddOptionsModal, setShowAddOptionsModal] = useState(false);
	const [name, setName] = useState<string | undefined>(packageToEdit?.name);
	const [price, setPrice] = useState<number | undefined>(packageToEdit ? parseInt(packageToEdit.price) : undefined);
	const [options, setOptions] = useState<OptionType[]>(packageToEdit?.options ?? []);

	const client = useApolloClient();
	const dispatch = useDispatch();

	const hideModal = () => {
		onCreateFinished();
	};

	const setUpdatedRegion = (regionToUpdate) => {
		dispatch(setSelectedRegion(regionToUpdate));
	};

	const onDelete = () =>
		CreatePartnerPackageModalHelper.updatePackage(true, client, onCreateFinished, partner, name, price, options, selectedRegion, packageToEdit, setUpdatedRegion);

	const renderCardInputs = () => {
		return (
			<div>
				<UIListInputRow
					label={'Package name'}
					placeholder={'Gold, Standard, Premium, etc...'}
					value={name}
					savedValue={packageToEdit?.name}
					onChangeValue={setName}
				/>
				<UIListInputRow
					prefix={'$'}
					type={UI_LABELED_INPUT_CURRENCY_TYPE}
					label={'Set package price'}
					placeholder={'$199'}
					value={`${price ? price / 100 : undefined}`}
					savedValue={packageToEdit ? parseInt(packageToEdit.price) / 100 : undefined}
					onChangeNumberValue={(packagePrice) => setPrice(packagePrice * 100)}
				/>
				<div className='createPartner'>
					{options.length > 0 &&
						options.map((option, key) => (
							<div className='createPartner__options' key={option.id}>
								<UIBookableOption
									key={key}
									bookableOption={setUpBookableOption(option, [])}
									onClick={() => CreatePartnerPackageModalHelper.removeOption(option.id, setOptions, options)}
									disableSelection={false}
								/>
							</div>
						))}
				</div>
			</div>
		);
	};

	const renderPackageButtons = () => {
		return (
			<div className='createPartner__buttons'>
				<UIIconButton
					dark
					text={options.length > 0 ? 'select more options' : 'select options'}
					onClick={() => setShowAddOptionsModal(true)}
					icon={PlusIcon.darkGrey}
				/>
				<UIIconButton
					dark
					isDisabled={CreatePartnerPackageModalHelper.isPackageValid(options, price, name) !== true}
					text={packageToEdit ? 'update package' : 'create package'}
					onClick={() =>
						CreatePartnerPackageModalHelper.updatePackage(
							false,
							client,
							onCreateFinished,
							partner,
							name,
							price,
							options,
							selectedRegion,
							packageToEdit,
							setUpdatedRegion
						)
					}
				/>
			</div>
		);
	};

	const addOptionsModal = () => {
		const hideModal = () => setShowAddOptionsModal(false);
		const selectOptionModal = (selectedOption) => {
			if (options.length > 0) {
				const filteredOptions = options.filter((option) => option.id !== selectedOption.id);
				setOptions([...filteredOptions, selectedOption]);
			} else {
				setOptions([selectedOption]);
			}
			hideModal();
		};
		return (
			<UIModal condition={showAddOptionsModal}>
				<SelectOptionModal hideModal={hideModal} filterType={undefined} selectOption={(selectedOption) => selectOptionModal(selectedOption)} />
			</UIModal>
		);
	};

	return (
		<UIOverlayCard
			title={packageToEdit ? 'Update package' : `Create package for ${partner?.name}`}
			hideModal={hideModal}
			rightItem={packageToEdit && <UIIcon className={'createPartner__icon'} iconSrc={Trashcan.white} onClick={onDelete} alt={'delete'} />}>
			{renderCardInputs()}
			{renderPackageButtons()}
			{addOptionsModal()}
		</UIOverlayCard>
	);
}
